// https://sia4g461nve.typeform.com/to/YrfjLJ1b
const TYPEFORM_REGEX = /^(https?:\/\/([a-zA-Z0-9]+).typeform.com\/to\/([a-zA-Z0-9]+))/i;
const JOTFORM_REGEX = /^(https?:\/\/form.jotform.com\/([0-9]+|[a-zA-Z_-]+\/[a-zA-Z_-]+))/i;
function getTypeformId(url) {
  const match = url.match(TYPEFORM_REGEX);
  return match ? match[3] : false;
}
function getJotformId(url) {
  const match = url.match(JOTFORM_REGEX);
  return match ? match[2] : false;
}
const TYPEFORM_OPTIONS = {
  id: 'typeform',
  name: 'Typeform',
  urlPatterns: [TYPEFORM_REGEX],
  getId: getTypeformId,
  icon: 'TypeformIcon',
  iconColor: '#262627',
  type: 'form'
};
const JOTFORM_OPTIONS = {
  id: 'jotform',
  name: 'Jotform',
  urlPatterns: [JOTFORM_REGEX],
  getId: getJotformId,
  icon: 'JotformIcon',
  iconColor: '#7EC10E',
  type: 'form'
};
const FORM_OPTIONS = [TYPEFORM_OPTIONS, JOTFORM_OPTIONS];
export { FORM_OPTIONS, JOTFORM_OPTIONS, JOTFORM_REGEX, TYPEFORM_OPTIONS, TYPEFORM_REGEX, getJotformId, getTypeformId };